import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { CardView, rem } from 'design-system';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { selectIsGBUser } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { tierThemes } from '../benefits';
import { getThemeGradient } from '../colors';
import { Tier } from '../entities';
import { selectEligibleFreeTrialDays, selectShouldSeePremiumTrialScreen, } from '../selectors';
import Badge from './Badge';
const SubscriptionCard = ({ tier, price, yearlyPrice, discount, children, showTrialWithChildren, style, showDescription = true, }) => {
    const theme = tierThemes[tier];
    const colors = useColors();
    const themeColors = getThemeGradient(tier, colors);
    const shouldSeePremiumTrialScreen = useAppSelector((store) => selectShouldSeePremiumTrialScreen(store, tier));
    const isGbUser = useAppSelector(selectIsGBUser);
    const eligibleFreeTrialDays = useAppSelector(selectEligibleFreeTrialDays);
    const description = isGbUser ? theme.descriptionGB : theme.description;
    return (<CardView style={[
            styles.container,
            children ? styles.containerWithChildren : undefined,
            style,
        ]} noMarginTop>
      <View style={children ? styles.containerWithChildrenInner : undefined}>
        <View style={styles.row}>
          <Text Text-24>{theme.name}</Text>
          {discount && tier !== Tier.free ? <Badge>{discount}</Badge> : null}
        </View>
        <View style={[
            styles.priceContainer,
            tier === Tier.free && styles.priceContainerFree,
        ]}>
          {tier !== Tier.free && Boolean(yearlyPrice) && (<Text OffBlack Numbers-16 style={styles.monthlyPrice}>
              {price}
            </Text>)}
          {Boolean(yearlyPrice || price) && (<>
              <Text color={themeColors?.colors?.[1]} Numbers-20>
                {yearlyPrice || price}
              </Text>
              <Text TextThin-14 Gray flex style={styles.period}>
                {tier === Tier.free
                ? '/ free forever'
                : `/ month${yearlyPrice ? ', renews annually' : ''}`}
              </Text>
            </>)}
        </View>
        {!!description && !!showDescription && (<Text TextThin-14 Gray style={styles.descriptionPadding}>
            {description}
          </Text>)}
        {(!children || showTrialWithChildren) &&
            shouldSeePremiumTrialScreen &&
            tier !== Tier.free ? (<>
            <Spacer h={rem(8)}/>
            <Text Text-16>Try {eligibleFreeTrialDays} days for free!</Text>
          </>) : null}
      </View>
      {children}
    </CardView>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    container: {
        paddingHorizontal: rem(16),
        paddingTop: rem(16),
        paddingBottom: rem(8),
        marginTop: rem(16),
        marginBottom: rem(0),
    },
    containerWithChildren: {
        paddingHorizontal: 0,
    },
    containerWithChildrenInner: {
        paddingHorizontal: rem(16),
        paddingBottom: rem(24),
    },
    monthlyPrice: {
        textDecorationLine: 'line-through',
        marginRight: rem(8),
        marginTop: rem(2),
    },
    priceContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: rem(4),
        marginBottom: rem(8),
    },
    priceContainerFree: {
        marginBottom: 0,
    },
    period: {
        marginLeft: rem(8),
    },
    descriptionPadding: {
        paddingBottom: rem(8),
    },
});
export default memo(SubscriptionCard);
